module.exports = __webpack_public_path__ + "static/media/JoanaDias.fdcc73f2.png";